var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.PublicBlogPage,{attrs:{"page-type":"article"}},[_c('transition',{attrs:{"name":"bcx-transition-fade"}},[_c(_setup.BlogArticle,{attrs:{"article-id":_vm.articleId,"mode":"public"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }